/**
 * Launches API.
 *
 * Thin wrapper around the shared api client (see api/tracks.js for the
 * pattern). The backend proxies Launch Library 2 and returns a shaped
 * { starship, upcoming } payload — the client just names the endpoint.
 */

import { api } from './client.js';

export const getLaunches = () => api.get('/api/launches');
